/**
 * Clemtex.CategoryLinks.Data - network + caching.
 *
 *   /site/category-links.json   published by bb_ss_cx_publish.js. Fetched once per
 *                               page life with an hourly cache key (the CDN holds
 *                               /site/ files for 7 days, so a fixed URL would go stale).
 *   /api/items ... limit=1      live product count per linked category (what THIS
 *                               shopper can see). sessionStorage, 30 minutes.
 *   /api/items ... id=a,b,c     featured-part cards on product pages.
 *
 * Native fetch() only (no jQuery.ajax: the core's ajaxPrefilter adds headers we
 * don't need; see the SCEDT CLAUDE.md). Every failure resolves quietly - a link
 * without a count still renders; a missing file renders nothing.
 */
define('Clemtex.CategoryLinks.Data', ['Clemtex.CategoryLinks.Rules'], function (Rules) {
    'use strict';

    var COUNT_TTL_MS = 30 * 60 * 1000;
    var payloadPromise = null;
    var countPromises = {};

    function store() {
        try { return window.sessionStorage; } catch (e) { return null; }
    }
    function readCache(key) {
        var s = store();
        if (!s) { return null; }
        try {
            var v = JSON.parse(s.getItem(key) || 'null');
            return v && v.exp > Date.now() ? v.val : null;
        } catch (e) { return null; }
    }
    function writeCache(key, val, ttl) {
        var s = store();
        if (!s) { return; }
        try { s.setItem(key, JSON.stringify({ val: val, exp: Date.now() + ttl })); } catch (e) { /* quota / private mode */ }
    }

    function siteParams() {
        var env = window.SC && window.SC.ENVIRONMENT;
        var site = env && env.siteSettings;
        return env && env.companyId && site && site.siteid ? { c: env.companyId, n: site.siteid } : null;
    }

    function getJson(url) {
        if (typeof window.fetch !== 'function') { return Promise.reject(new Error('fetch unavailable')); }
        return window.fetch(url, { credentials: 'same-origin' }).then(function (r) {
            if (!r.ok) { throw new Error('HTTP ' + r.status); }
            return r.json();
        });
    }

    /** The published link map (or null). One request per page life. */
    function payload() {
        if (!payloadPromise) {
            payloadPromise = getJson('/site/category-links.json?v=' + Rules.hourBucket())
                .catch(function () { payloadPromise = null; return null; });
        }
        return payloadPromise;
    }

    /** Live product count for a category URL, or null when unknown. */
    function count(catId, fullurl) {
        var key = 'cx:count:' + catId;
        var cached = readCache(key);
        if (cached !== null && cached !== undefined) { return Promise.resolve(cached); }
        if (countPromises[key]) { return countPromises[key]; }
        var p = siteParams();
        if (!p || !fullurl) { return Promise.resolve(null); }
        countPromises[key] = getJson(Rules.itemsApiUrl(p, { commercecategoryurl: fullurl, limit: 1, offset: 0 }))
            .then(function (r) {
                var total = r && typeof r.total === 'number' ? r.total : null;
                if (total !== null) { writeCache(key, total, COUNT_TTL_MS); }
                return total;
            })
            .catch(function () { return null; })
            .then(function (v) { delete countPromises[key]; return v; });
        return countPromises[key];
    }

    /** Card data for featured part ids (order preserved, missing ones dropped). */
    function cards(ids) {
        var p = siteParams();
        if (!p || !ids || !ids.length) { return Promise.resolve([]); }
        return getJson(Rules.itemsApiUrl(p, { id: ids.join(','), limit: ids.length }))
            .then(function (r) {
                var byId = {};
                ((r && r.items) || []).forEach(function (it) { byId[String(it.internalid)] = it; });
                return ids.map(function (id) { return Rules.cardFromItem(byId[String(id)]); }).filter(Boolean);
            })
            .catch(function () { return []; });
    }

    return { payload: payload, count: count, cards: cards, siteParams: siteParams };
});
